<template>
  <template v-if="!asModal">
    <HoverTooltip :clickable="clickable">
      <template #default>
        <DsIcon
          name="info-circle"
          :size="iconSize"
          class="cursor-help text-blue-500"
        />
      </template>

      <template #tooltip>
        <slot />
      </template>
    </HoverTooltip>
  </template>

  <div v-else>
    <DsIcon
      name="info-circle"
      :size="iconSize"
      class="cursor-pointer text-blue-500"
      @click="open"
    />

    <DsModal
      ref="modal"
      :show="showModal"
      :title="modalTitle"
      size="lg"
      cancel-only
      @cancel="close"
    >
      <div class="max-w-[100vw] overflow-x-auto">
        <slot />
      </div>
    </DsModal>
  </div>
</template>

<script lang="ts" setup>
import { DsIcon, DsModal, IconSize } from '@demvsystems/design-components';

import HoverTooltip from '@/components/global/HoverTooltip/HoverTooltip.vue';
import { useModal } from '@/utils/useModal/useModal';
import { MODAL } from '@/utils/useModal/types';

interface Props {
  iconSize?: IconSize;
  clickable?: boolean;
  asModal?: boolean;
  modalTitle?: string;
}

withDefaults(defineProps<Props>(), {
  iconSize: 'lg',
  modalTitle: '',
});

const { showModal, open, close } = useModal(MODAL.GENERIC_INFO_MODAL);
</script>
